const UserRole = {
  ADMIN: 'admin',
  EDITOR: 'editor',
  WRITER: 'writer',
  CUSTOMER: 'customer',
  DEVELOPMENTAL_EDITOR: 'developmentalEditor',
  SALE: 'sale',
  CONTENT_TEAM: 'contentTeam',
  PRO_PROOFREADER: 'proProofreader',
};

module.exports = UserRole;
